import { IClinic } from '../interface/clinic';
export class Clinic implements IClinic {
    
    constructor(public ClinicId : number,public ClinicName : string,public ClinicAddress : string,public ClinicContactNo : number, public ClinicOpeningTime : string,public  ClinicClosingTime : string, public OrganizationId : number, public OrganizationName : string ){
        
    }
   
}



// WEBPACK FOOTER //
// ./src/app/section/master/model/clinic.ts